"use strict";

var _interopRequireWildcard = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  countryCodes: [],
  introduction: '',
  roles: [],
  isBindGoogleAuth: false,
  isLock: _jsCookie.default.get('isLock') || false,
  lockPasswd: _jsCookie.default.get('lockPasswd') || ''
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_COUNTRYCODES: function SET_COUNTRYCODES(state, countryCodes) {
    state.countryCodes = countryCodes;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_LOCK_PASSWD: function SET_LOCK_PASSWD(state, lockPasswd) {
    state.lockPasswd = lockPasswd;
    _jsCookie.default.set('lockPasswd', state.lockPasswd);
  },
  SET_LOCK: function SET_LOCK(state, action) {
    state.isLock = true;
    _jsCookie.default.set('isLock', state.isLock);
  },
  CLEAR_LOCK: function CLEAR_LOCK(state, action) {
    state.isLock = false;
    state.lockPasswd = '';
    _jsCookie.default.remove('lockPasswd');
    _jsCookie.default.remove('isLock');
  },
  SET_IS_BIND_GOOGLE_AUTH: function SET_IS_BIND_GOOGLE_AUTH(state, flag) {
    state.isBindGoogleAuth = flag;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password,
      googleCode = userInfo.googleCode,
      account = userInfo.account;
    return new Promise(function (resolve, reject) {
      (0, _user.login)({
        username: username.trim(),
        password: password,
        googleCode: googleCode,
        account: account
      }).then(function (response) {
        var data = response.data;
        // 注：必须要用commit('SET_TOKEN', data.token)调用mutations里的方法，才能在store存储成功。
        commit('SET_TOKEN', data.token);
        (0, _auth.setToken)(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          username = data.username,
          avatar = data.avatar,
          countryCodes = data.countryCodes,
          introduction = data.introduction,
          isBindGoogleAuth = data.isBindGoogleAuth;
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        // const url = window.location.host
        // if (url === process.env.VUE_APP_URL_ADMIN_HOST) {
        // }
        commit('SET_ROLES', roles);
        commit('SET_NAME', username);
        commit('SET_AVATAR', avatar);
        commit('SET_COUNTRYCODES', countryCodes);
        commit('SET_INTRODUCTION', introduction);
        commit('SET_IS_BIND_GOOGLE_AUTH', isBindGoogleAuth);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('CLEAR_LOCK');
        (0, _auth.removeToken)();
        (0, _router.resetRouter)();

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref5, role) {
    var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};